module.exports = __webpack_public_path__ + "static/artist-marketing-the-process-bad7a37f0260eedd6a5857d9fdeabae2.png";